/* Collection SEO guide: builds an "On this page" list from the description's H2s and adds a
   read-more clamp. Text and headings are never changed or removed (all stays in the DOM). */
(function () {
  function init() {
    var art = document.querySelector('article.bb-seo');
    if (!art || art.dataset.bbSeo) return;
    art.dataset.bbSeo = '1';
    var body = art.querySelector(':scope > div');
    if (!body || body.innerText.trim().length < 200) { art.classList.add('bb-seo--short'); return; }
    body.classList.add('bb-seo__body');

    var head = document.createElement('div');
    head.className = 'bb-seo__head';
    head.innerHTML = '<p class="bb-seo__eyebrow">Buying guide</p>';
    art.insertBefore(head, body);

    var h2s = body.querySelectorAll('h2');
    if (h2s.length >= 3) {
      var nav = document.createElement('nav');
      nav.className = 'bb-seo__toc';
      nav.setAttribute('aria-label', 'On this page');
      var html = '<p>On this page</p><ol>';
      h2s.forEach(function (h, i) {
        if (!h.id) h.id = 'guide-' + (h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || i);
        html += '<li><a href="#' + h.id + '">' + h.textContent.trim().replace(/</g, '&lt;') + '</a></li>';
      });
      nav.innerHTML = html + '</ol>';
      art.classList.add('bb-seo--toc');
      art.insertBefore(nav, body);
      nav.addEventListener('click', function (e) {
        var a = e.target.closest('a'); if (!a) return;
        art.classList.remove('bb-seo--clamped');
        var btn = art.querySelector('.bb-seo__more'); if (btn) btn.remove();
      });
    }

    var limit = window.matchMedia('(max-width: 760px)').matches ? 520 : 760;
    if (body.scrollHeight > limit + 240) {
      art.classList.add('bb-seo--clamped');
      body.style.setProperty('--bb-clamp', limit + 'px');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'bb-seo__more';
      more.textContent = 'Read the full guide';
      more.addEventListener('click', function () {
        art.classList.remove('bb-seo--clamped');
        more.remove();
      });
      art.appendChild(more);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
